import { BaseModel } from "pages/Core/base.model";

export class ProductTypeFormModel extends BaseModel {
    productType!: string;

    static setProductTypeFromData(data: ProductTypeFormModel): ProductTypeFormModel {
        const model = new ProductTypeFormModel();
        model.id = data.id ?? 0;
        model.productType = data.productType ?? '';
        return model;
    }
}
